export interface IXenaAppBundleTranslation {
  name?: string;
  description?: string;
  details?: string;
  termsMarkdown?: string;
}
